import React from "react";
import { Button } from "@/components/ui/button";
import { ClipboardList, Info, Loader2 } from "lucide-react";

interface SubmitAreaProps {
  saving: boolean;
  submitError: string | null;
  hasServiceType: boolean;
  isAddProvider: boolean;
  /** When set, Submit is disabled and this text explains why. */
  submitBlockedReason?: string;
  onSubmit: () => void;
  onReset: () => void;
  onBack?: () => void;
}

export function SubmitArea({
  saving,
  submitError,
  hasServiceType,
  isAddProvider,
  submitBlockedReason,
  onSubmit,
  onReset,
  onBack,
}: SubmitAreaProps) {
  const submitDisabled = saving || !!submitBlockedReason;
  return (
    <>
      {submitError && (
        <div className="flex items-start gap-2 rounded-md border border-destructive bg-destructive/10 px-3 py-2.5">
          <Info className="h-4 w-4 text-destructive shrink-0 mt-0.5" />
          <p className="text-sm text-destructive">{submitError}</p>
        </div>
      )}

      {isAddProvider && (
        <p className="text-xs text-muted-foreground">
          Clicking submit will add selected staff to the correct authorization
          codes effective today.
        </p>
      )}

      {hasServiceType && submitBlockedReason && !saving && (
        <p className="text-xs text-muted-foreground">{submitBlockedReason}</p>
      )}

      {hasServiceType && (
        <div className="flex items-center gap-3 pt-1">
          <Button
            onClick={onSubmit}
            disabled={submitDisabled}
            title={submitBlockedReason}
            className="min-w-[100px]"
          >
            {saving ? (
              <>
                <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />
                Submitting…
              </>
            ) : (
              <>
                <ClipboardList className="h-4 w-4 mr-1.5" />
                Submit Request
              </>
            )}
          </Button>
          <Button variant="outline" onClick={onReset} disabled={saving}>
            Clear
          </Button>
          {onBack && (
            <Button variant="ghost" onClick={onBack} disabled={saving}>
              Cancel
            </Button>
          )}
        </div>
      )}
    </>
  );
}
